import Manifesto from "@/components/sections/Manifesto";
import Testimonials from "@/components/sections/Testimonials";
import WhyUs from "@/components/sections/WhyUs";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { SEO_MAP } from "@/lib/seoMap";

export default function AboutPage() {
  return (
    <main data-testid="about-page">
      <SEO {...SEO_MAP.about} />
      <PageHeader overline="About" title={<>The digital arm of<br /><em className="italic">LaneX Holdings</em>.</>}
                  lead="A team of engineers, designers and operators building the software backbone of ambitious businesses." />
      <Manifesto />
      <WhyUs />
      <Testimonials />
    </main>
  );
}
